<template>
    <div>
        <b-alert show>
            <h4>
                FILTROS
                <app-status :status="filtrado ? 'APLICADO' : ''"></app-status>
                <app-status
                    class="ml-2"
                    :status="filtroModificado ? 'MODIFICADO' : ''"
                ></app-status>
            </h4>
            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Data Vencimento (DE)</label>
                        <date-picker
                            ref="dp01"
                            v-model="dataInicial"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                            placeholder="Informe a data inicial"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Data Vencimento (ATÉ)</label>
                        <date-picker
                            ref="dp02"
                            v-model="dataFinal"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                            placeholder="Informe a data final"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col>
                    <div class="mt-1">
                        <b-button
                            variant="warning"
                            class="mt-4"
                            @click.stop="filtrar()"
                            :disabled="desabilitarBtnPesquisar"
                        >
                            <i class="fa fa-search"></i> Pesquisar
                        </b-button>
                        <!-- <b-button
                            variant="primary"
                            class="mt-4"
                            @click.stop="limparFiltros()"
                            v-if="filtrado"
                        >
                            <i class="fa fa-eraser"></i> Limpar
                        </b-button> -->
                    </div>
                </b-col>
            </b-row>
        </b-alert>
    </div>
</template>

<script>
export default {
    components: {},

    data() {
        return {
            dataInicial: null,
            dataFinal: null,
            filtrado: false,
            filtroAplicado: {}
        }
    },

    methods: {
        filtrar() {
            this.filtroAplicado = this.filtro
            this.$emit('aplicarFiltro', this.filtro)
            this.filtrado = true
        },

        limparFiltros() {
            this.dataInicial = null
            this.dataFinal = null
            this.$emit('aplicarFiltro')
            this.filtrado = false
            this.filtroAplicado = {}
        }
    },

    created() {},

    computed: {
        filtroModificado() {
            return (
                !this._.isEqual(this.filtro, this.filtroAplicado) &&
                this.filtrado
            )
        },

        filtro() {
            let filtroTemp = {
                dataInicial: this.dataInicial
                    ? this.$moment(this.dataInicial, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : '',
                dataFinal: this.dataFinal
                    ? this.$moment(this.dataFinal, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : ''
            }
            return filtroTemp
        },

        desabilitarBtnPesquisar() {
            return !(this.dataInicial && this.dataFinal)
        }
    },

    watch: {
        dataInicial() {
            if (this.dataInicial) {
                this.$refs.dp02.dp.minDate(this.dataInicial)
            } else {
                this.$refs.dp02.dp.minDate(false)
            }
        },

        dataFinal() {
            if (this.dataFinal) {
                this.$refs.dp01.dp.maxDate(this.dataFinal)
            } else {
                this.$refs.dp01.dp.maxDate(false)
            }
        }
    }
}
</script>
